import { CustomElement, OverrideCustomElementConfig } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { JUSTIFY_CONTENT } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CheckboxOptions, CheckboxValue, CjsCheckbox } from "../../components/checkbox/checkbox";
import { CjsEditor, EditorOptions, defaultEditorOptions } from "../editor";

export type CheckboxEditorOptions = EditorOptions;

/**
 * Checkbox editor class
 */
@CustomElement({
    name: "cjs-checkbox-editor",
    style: require("./checkboxEditor.scss"),
    elementCssClasses: ["cjs-editor"]
})
export class CjsCheckboxEditor extends CjsEditor<CheckboxValue> {

    /** Checkbox component */
    protected _checkbox = new CjsCheckbox({ checkboxHorizontalAlignment: JUSTIFY_CONTENT.START });// For editor, always align checkbox at start of editor

    /** Editor options */
    @TypedWebComponentOptions(defaultEditorOptions)
    public readonly options!: WebComponentOptions<CheckboxEditorOptions>;

    /** Checkbox options */
    public get checkboxOptions(): WebComponentOptions<CheckboxOptions> {
        return this._checkbox.options;
    }

    constructor(options?: Partial<CheckboxEditorOptions>, checkboxOptions?: Partial<CheckboxOptions>, customElementOptions?: OverrideCustomElementConfig) {
        super(customElementOptions);
        this.options.setWithoutRefresh(options);
        this.checkboxOptions.setWithoutRefresh(checkboxOptions);
    }

    /** 
     * Get input of Editor, where user set data 
     */
    public getInput(): CjsCheckbox {
        return this._checkbox;
    }

    /**
     * Init editor
     */
    public override init(): void {
        super.init();

        // Append checkbox component
        this.append(this._checkbox);

        // Callback for input components
        this._checkbox.toggleEvent.on(_ => this._onInputValueChange());
    }

    /** 
     * Refresh editor 
     */
    public override refresh(): void {
        super.refresh();
        this._checkbox.refresh();
    }

    /** Set formCheckInput as validation form element */
    public override getValidationFormElement(): HTMLElement {
        return this._checkbox.components.formCheckInput;
    }

    /**
     * Update the input value from stored value
     */
    protected _refreshInputValue(): void {
        this._checkbox.setValue(this._value ?? false);
    }

    /**
     * Gets the value corresponding to the current input value
     */
    protected _getValueFromInputComponent(): CheckboxValue {
        return this._checkbox.getValue();
    }

    /** Update disabled attribute on input component */
    protected _refreshDisabled(): void {
        this.checkboxOptions.setAndRefreshIfChanged({
            disabled: this.disabled
        });
    }
}